import { IMLThamSoPhongHocMonHoc } from "../../model/respone/category/IMLThamSoPhongHocMonHoc";
import { apiClient } from "../apiClient";

// Route khớp với MLThamSoPhongHocMonHocController = api/tham-so-phong-hoc-mon-hoc
export const ML_THAM_SO_PHONG_HOC_MON_HOC_API = "tham-so-phong-hoc-mon-hoc";
export const mlThamSoPhongHocMonHocApi = {
  SelectAll: () => apiClient.get(`${ML_THAM_SO_PHONG_HOC_MON_HOC_API}`),
  Insert: (payload: IMLThamSoPhongHocMonHoc) => apiClient.post(`${ML_THAM_SO_PHONG_HOC_MON_HOC_API}`, payload),
  Update: (payload: IMLThamSoPhongHocMonHoc) => apiClient.put(`${ML_THAM_SO_PHONG_HOC_MON_HOC_API}`, payload),
  Delete: (id: number) => apiClient.delete(`${ML_THAM_SO_PHONG_HOC_MON_HOC_API}/${id}`),
};
